
export const APPLICATION_TAB_NAME = "Applications"
export const MODULE_TAB_NAME = "XR Modules"
export const ENVIRONMENT_TAB_NAME = "Environments"
export const SKILL_STREAM_TAB_NAME = "Skill Stream"
export const SKILL_SCHOOL_TAB_NAME = "Skill School"
export const AR_CONTENT_TAB_NAME = "AR Content"

export const GROUP_TAB_TYPE = "groups";
export const USER_TAB_TYPE = "users";
export const APPLICATION_TAB_TYPE = "applications";
export const ALL = "all";
export const RESOURCE_APPLICATION_TAB = "applicationTab";
export const RESOURCE_MODULE_TAB = "moduleTab";
export const RESOURCE_ENVIRONMENT_TAB = "environmentTab";
export const RESOURCE_SKILL_STREAM_TAB = "skillStreamTab";
export const RESOURCE_SKILL_SCHOOL_TAB = "skillSchoolTab";
export const AR_CONTENT_TAB = "arContentTab";
export const MODULE_LIMIT = 25;
export const APPLICATION_LIMIT = 500;
export const GROUP_LIMIT = 25;


export const USER_LIMIT = 25;
export const APPLICATION = "APPLICATION";
export const ENVIRONMENT = "ENVIRONMENT";
export const MODULE = "MODULE";
export const SKILL = "SKILL";
export const SKILLSCHOOL = "SKILLSCHOOL";
export const ARCONTENT = "ARCONTENT";
export const OLD_PASSWORD = "OLD_PASSWORD"
export const NEW_PASSWORD = "NEW_PASSWORD"
export const CONFIRM_PASSWORD = "CONFIRM_PASSWORD"

export const ROLE_ASSIGNMENTS = 'ROLE_ASSIGNMENTS';

export const TABS_TYPE_KEY = {
  [ALL]: "ALL",
  [USER_TAB_TYPE]: "user",
  [GROUP_TAB_TYPE]: "group",
  [RESOURCE_APPLICATION_TAB]: "APPLICATION",
  [RESOURCE_MODULE_TAB]: "MODULE",
  [RESOURCE_ENVIRONMENT_TAB]: "ENVIRONMENT",
  [RESOURCE_SKILL_STREAM_TAB]: "SKILL",
  [RESOURCE_SKILL_SCHOOL_TAB]: "SKILLSCHOOL",
  [AR_CONTENT_TAB]: "ARCONTENT",
};

export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/avif"];

export const statusOptions = [
  { value: "active", name: "Active", key: true, type: "status" },
  { value: "inactive", name: "Inactive", key: false, type: "status" },
];

export const userPdfHeader = ["S.N", "Name", "Email", "UID", "Phone", "Designation", "Role"];
export const groupPdfHeader = ["S.N", "Name", "Role", "Groups", "Users"];

export const exportListHeaders = {
  [USER_TAB_TYPE]: userPdfHeader,
  [GROUP_TAB_TYPE]: groupPdfHeader,
};

export const exportListFileName = {
  [USER_TAB_TYPE]: "Users list",
  [GROUP_TAB_TYPE]: "Groups list",
};

export function getDeviceName() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) {
    return "Android";
  }
  if (/ipad|tablet/i.test(userAgent)) {
    return "Tablet";
  }
  if (/iphone|ipod/i.test(userAgent)) {
    return "iOS";
  }
  if (/windows/i.test(userAgent) && /touch/i.test(userAgent)) {
    return "Windows Tablet";
  }
  if (/windows/i.test(userAgent)) {
    return "Windows PC";
  }
  if (/macintosh/i.test(userAgent)) {
    return "Mac Laptop/Desktop";
  }
  if (/linux/i.test(userAgent)) {
    return "Linux";
  }
  return "UNKNOWN";
}

export function getDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/i.test(userAgent)) {
    return "Handheld";
  }
  if (/ipad|tablet/i.test(userAgent)) {
    return "Handheld";
  }
  if (/iphone|ipod/i.test(userAgent)) {
    return "Handheld";
  }
  if (/windows/i.test(userAgent) && /touch/i.test(userAgent)) {
    return "Desktop";
  }
  if (/windows/i.test(userAgent)) {
    return "Desktop";
  }
  if (/macintosh/i.test(userAgent)) {
    return "Desktop";
  }
  if (/linux/i.test(userAgent)) {
    return "Desktop";
  }
  return "UNKNOWN";
}

export const constantKeyMap = {
  "applicationTab": RESOURCE_APPLICATION_TAB,
  "moduleTab": RESOURCE_MODULE_TAB,
  "environmentTab": RESOURCE_ENVIRONMENT_TAB,
  "skillStreamTab": RESOURCE_SKILL_STREAM_TAB,
  "skillSchoolTab": RESOURCE_SKILL_SCHOOL_TAB,
  "arContentTab": AR_CONTENT_TAB,
}

export const mappingTabWithResourceTypes = {
  "applicationTab": "APPLICATION",
  "moduleTab": "MODULE",
  "environmentTab": "ENVIRONMENT",
  "skillStreamTab": "SKILL",
  "skillSchoolTab": "SKILLSCHOOL",
  "arContentTab": "ARCONTENT",
}

export const resourceTabNaming = {
  [RESOURCE_APPLICATION_TAB]: APPLICATION_TAB_NAME,
  [RESOURCE_MODULE_TAB]: MODULE_TAB_NAME,
  [RESOURCE_ENVIRONMENT_TAB]: ENVIRONMENT_TAB_NAME,
  [RESOURCE_SKILL_STREAM_TAB]: SKILL_STREAM_TAB_NAME,
  [RESOURCE_SKILL_SCHOOL_TAB]: SKILL_SCHOOL_TAB_NAME,
  [AR_CONTENT_TAB]: AR_CONTENT_TAB_NAME,
}